/* Mama Jewels: photo viewer for the product page, modelled on TOV Essentials.
   Replaces Dawn's lightbox (which opened the photo already zoomed in and cut off).
   - Mobile: white full screen, whole photo in view, swipe between photos, dots on top,
     pinch or double tap to zoom inside the photo, previous / close / next at the bottom.
   - Desktop: whole photo large in the middle, thumbnails on the left, click the photo or
     the cross to close, arrow keys and Esc work.
   Only the photos that are visible in the gallery are shown (hidden variant photos stay out). */
(function () {
  if (window.mjZoomReady) return;
  window.mjZoomReady = true;
  var mq = window.matchMedia('(max-width: 749px)');
  var MAX = 4, DOUBLE = 2.5, GAP = 40; /* GAP: white space between photos, so the next one never peeks in */
  var root, stage, track, dots, thumbs, slides = [], idx = 0, lastFocus;
  var z = { s: 1, x: 0, y: 0 };

  var ICON = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };

  function sized(img, w) {
    var s = img.getAttribute('src') || img.currentSrc || '';
    var set = img.getAttribute('srcset');
    if (set) {
      var best = 0;
      set.split(',').forEach(function (p) {
        var bits = p.trim().split(/\s+/), n = parseInt(bits[1], 10) || 0;
        if (n >= best) { best = n; s = bits[0]; }
      });
    }
    if (/[?&]width=\d+/.test(s)) s = s.replace(/([?&])width=\d+/, '$1width=' + w);
    else s += (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    return s.indexOf('//') === 0 ? 'https:' + s : s;
  }

  function galleryItems() {
    var list = document.querySelector('.product__media-wrapper .product__media-list');
    if (!list) return [];
    return [].filter.call(list.children, function (li) {
      return li.offsetWidth > 0 && li.querySelector('img');
    });
  }

  function build() {
    root = document.createElement('div');
    root.className = 'mjz';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Photos du produit');
    root.innerHTML =
      '<div class="mjz__thumbs"></div>' +
      '<div class="mjz__stage"><div class="mjz__track"></div></div>' +
      '<div class="mjz__dots" aria-hidden="true"></div>' +
      '<button type="button" class="mjz__x" data-mjz-close aria-label="Fermer">' + ICON.close + '</button>' +
      '<div class="mjz__bar">' +
        '<button type="button" data-mjz-prev aria-label="Photo précédente">' + ICON.prev + '</button>' +
        '<button type="button" data-mjz-close aria-label="Fermer">' + ICON.close + '</button>' +
        '<button type="button" data-mjz-next aria-label="Photo suivante">' + ICON.next + '</button>' +
      '</div>';
    document.body.appendChild(root);
    stage = root.querySelector('.mjz__stage');
    track = root.querySelector('.mjz__track');
    dots = root.querySelector('.mjz__dots');
    thumbs = root.querySelector('.mjz__thumbs');

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-mjz-close]')) return close();
      if (e.target.closest('[data-mjz-prev]')) return go(idx - 1);
      if (e.target.closest('[data-mjz-next]')) return go(idx + 1);
      var t = e.target.closest('[data-mjz-thumb]');
      if (t) return go(+t.getAttribute('data-mjz-thumb'));
      /* Desktop: clicking the photo closes, like TOV */
      if (!mq.matches && e.target.closest('.mjz__stage')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(idx - 1);
      else if (e.key === 'ArrowRight') go(idx + 1);
    });
    window.addEventListener('resize', function () { if (root.classList.contains('is-open')) { resetZoom(false); place(false); } });
    touch();
  }

  function open(items, start) {
    if (!root) build();
    lastFocus = document.activeElement;
    track.innerHTML = '';
    thumbs.innerHTML = '';
    dots.innerHTML = '';
    slides = items.map(function (li, i) {
      var src = li.querySelector('img');
      var slide = document.createElement('div');
      slide.className = 'mjz__slide';
      var img = document.createElement('img');
      img.className = 'mjz__img';
      img.alt = src.alt || '';
      img.draggable = false;
      img.setAttribute('data-src', sized(src, 2000));
      img.setAttribute('data-quick', src.currentSrc || src.src || ''); /* already loaded, shown until the sharp one arrives */
      slide.appendChild(img);
      track.appendChild(slide);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mjz__thumb';
      b.setAttribute('data-mjz-thumb', i);
      b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' sur ' + items.length);
      b.innerHTML = '<img src="' + sized(src, 200) + '" alt="" loading="lazy">';
      thumbs.appendChild(b);
      dots.appendChild(document.createElement('span'));
      return img;
    });
    root.classList.toggle('is-single', slides.length < 2);
    root.classList.add('is-open');
    document.documentElement.classList.add('mjz-lock');
    idx = Math.max(0, Math.min(start, slides.length - 1));
    place(false);
    var x = root.querySelector(mq.matches ? '.mjz__bar [data-mjz-close]' : '.mjz__x');
    if (x) x.focus({ preventScroll: true });
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('mjz-lock');
    resetZoom(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function load(i) {
    var img = slides[i];
    if (!img || img.getAttribute('data-loading')) return;
    img.setAttribute('data-loading', '1');
    var quick = img.getAttribute('data-quick'), big = img.getAttribute('data-src');
    if (quick) img.src = quick;
    var pre = new Image();
    pre.onload = function () { img.src = big; };
    pre.src = big;
  }

  function place(anim) {
    track.classList.toggle('is-anim', anim !== false);
    track.style.transform = 'translate3d(' + (-idx * (stage.clientWidth + GAP)) + 'px,0,0)';
    load(idx); load(idx + 1); load(idx - 1);
    [].forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === idx); });
    [].forEach.call(thumbs.children, function (t, i) {
      t.classList.toggle('is-on', i === idx);
      if (i === idx && t.scrollIntoView && root.classList.contains('is-open')) t.scrollIntoView({ block: 'nearest' });
    });
    var prev = root.querySelector('[data-mjz-prev]'), next = root.querySelector('[data-mjz-next]');
    prev.disabled = idx === 0;
    next.disabled = idx === slides.length - 1;
  }

  function go(i) {
    if (i < 0 || i >= slides.length || i === idx) return;
    resetZoom(true);
    idx = i;
    place(true);
  }

  /* ---------- zoom (mobile) ---------- */
  function box() { return { w: stage.clientWidth, h: stage.clientHeight }; }
  function clamp() {
    var b = box();
    z.x = Math.min(0, Math.max(b.w - z.s * b.w, z.x));
    z.y = Math.min(0, Math.max(b.h - z.s * b.h, z.y));
  }
  function paint(anim) {
    var img = slides[idx];
    if (!img) return;
    img.classList.toggle('is-anim', !!anim);
    img.style.transform = z.s === 1 ? '' : 'translate3d(' + z.x + 'px,' + z.y + 'px,0) scale(' + z.s + ')';
    root.classList.toggle('is-zoomed', z.s > 1);
  }
  function resetZoom(anim) { z.s = 1; z.x = 0; z.y = 0; paint(anim); }

  function touch() {
    var start = null, lastTap = 0, lastTapX = 0, lastTapY = 0;
    function pt(t) { var r = stage.getBoundingClientRect(); return { x: t.clientX - r.left, y: t.clientY - r.top }; }
    function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        var a = pt(e.touches[0]), b = pt(e.touches[1]);
        if (start && start.mode === 'swipe') place(false);
        start = { mode: 'pinch', d: dist(a, b), m: mid(a, b), s: z.s, x: z.x, y: z.y };
      } else if (e.touches.length === 1) {
        var p = pt(e.touches[0]);
        start = { mode: z.s > 1 ? 'pan' : 'swipe', p: p, x: z.x, y: z.y, t: Date.now(), moved: false };
        if (start.mode === 'swipe') track.classList.remove('is-anim');
      }
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (!start) return;
      e.preventDefault();
      if (start.mode === 'pinch' && e.touches.length === 2) {
        var a = pt(e.touches[0]), b = pt(e.touches[1]), m = mid(a, b);
        var s = Math.min(MAX, Math.max(1, start.s * dist(a, b) / start.d));
        var cx = (start.m.x - start.x) / start.s, cy = (start.m.y - start.y) / start.s;
        z.s = s; z.x = m.x - s * cx; z.y = m.y - s * cy;
        clamp(); paint(false);
      } else if (e.touches.length === 1) {
        var p = pt(e.touches[0]);
        var dx = p.x - start.p.x, dy = p.y - start.p.y;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) start.moved = true;
        if (start.mode === 'pan') {
          z.x = start.x + dx; z.y = start.y + dy; clamp(); paint(false);
        } else if (start.mode === 'swipe') {
          var w = stage.clientWidth, edge = (idx === 0 && dx > 0) || (idx === slides.length - 1 && dx < 0);
          track.style.transform = 'translate3d(' + (-idx * (w + GAP) + (edge ? dx / 3 : dx)) + 'px,0,0)';
        }
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (!start) return;
      var s = start;
      if (s.mode === 'pinch') {
        if (e.touches.length === 1) {
          /* one finger left: continue as a pan */
          start = { mode: z.s > 1 ? 'pan' : 'swipe', p: pt(e.touches[0]), x: z.x, y: z.y, t: Date.now(), moved: true };
          return;
        }
        if (z.s < 1.05) resetZoom(true);
        start = null;
        return;
      }
      start = null;
      var p = pt(e.changedTouches[0]);
      if (s.mode === 'swipe') {
        var dx = p.x - s.p.x, w = stage.clientWidth, fast = Math.abs(dx) > 30 && Date.now() - s.t < 250;
        if (dx < -w * 0.2 || (fast && dx < 0)) { if (idx < slides.length - 1) { idx++; } }
        else if (dx > w * 0.2 || (fast && dx > 0)) { if (idx > 0) { idx--; } }
        place(true);
      }
      /* double tap: zoom in at that point, or back out */
      if (!s.moved) {
        var now = Date.now();
        if (now - lastTap < 300 && Math.abs(p.x - lastTapX) < 30 && Math.abs(p.y - lastTapY) < 30) {
          if (z.s > 1) resetZoom(true);
          else { z.s = DOUBLE; z.x = p.x * (1 - DOUBLE); z.y = p.y * (1 - DOUBLE); clamp(); paint(true); }
          lastTap = 0;
        } else { lastTap = now; lastTapX = p.x; lastTapY = p.y; }
      }
    });
  }

  /* ---------- take over Dawn's lightbox ---------- */
  document.addEventListener('click', function (e) {
    var hit = e.target.closest('.product__media-wrapper .product__media-toggle, .product__media-wrapper .product__modal-opener');
    if (!hit) return;
    var li = hit.closest('.product__media-item');
    var items = galleryItems();
    var i = items.indexOf(li);
    if (!items.length || i < 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(items, i);
  }, true);
})();
